export interface StreamEnvironmentModel {
  id: number;
  uuid: string;
  name: string;
  description?: string;
  aws_region: string;
  aws_stack: string;
  aws_fleet: string;
  aws_app_ids: string;
  is_default: boolean | number;
  active: boolean | number;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export interface StreamEnvironmentFormValues {
  name: string;
  description?: string;
  aws_region: string;
  aws_stack: string;
  aws_fleet: string;
  aws_app_ids: string;
  is_default: boolean;
  active: boolean;
}

export const initialStreamEnvironmentFormValues: StreamEnvironmentFormValues = {
  name: '',
  description: '',
  aws_region: '',
  aws_stack: '',
  aws_fleet: '',
  aws_app_ids: 'studio',
  is_default: false,
  active: true,
};
